import { formatAmount } from "../../helpers/quickbooks";

export const ForecastInput = ({
    id,
    label,
    inputValue,
    access,
    setInputValue,
    calculatedValue = false,
    calculatedWithoutTransform = false,
    inputClassName = ""
}) => {
    return (
        <div className="space-y-2">
            <label
                className="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm select-none"
                htmlFor={id}
            >
                {label}
            </label>
            {calculatedValue ? (
                <div className="relative">
                    <input
                        className={`flex h-12 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-primary placeholder:text-gray-600 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed text-center ${inputClassName || ""}`}
                        id={id}
                        value={calculatedWithoutTransform ? formatAmount(inputValue, true, 0) : formatAmount(inputValue)}
                        disabled={true}
                    />
                </div>
            ) : (
                <input
                    className={`flex h-12 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-primary placeholder:text-gray-600 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed text-center ${inputClassName || ""}`}
                    id={id}
                    value={inputValue}
                    disabled={access !== "edit"}
                    onChange={(e) => {
                        if (access === "edit") {
                            let rawValue = e.target.value;
                            let normalizedValue = rawValue.replace(',', '.');
                            if (/^-?\d*\.?\d*$/.test(normalizedValue)) {
                                if (
                                    normalizedValue.includes('.') &&
                                    normalizedValue.startsWith('0') &&
                                    !normalizedValue.startsWith('0.') &&
                                    !normalizedValue.startsWith('-0.')
                                ) {
                                    normalizedValue = normalizedValue.replace(/^0+/, '') || '0';
                                } else if (!normalizedValue.includes('.') && normalizedValue.length > 1) {
                                    normalizedValue = normalizedValue.replace(/^(-?)0+/, '$1') || '0';
                                }
                                setInputValue?.(normalizedValue);
                            }
                        }
                    }}
                />
            )}
        </div>
    )
}